import React from "react";
import { IconButton, Badge, Tooltip } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useAlerts } from "../AlertsContext";
import { ALERTS_ENABLED } from "../constants";

/**
 * Campana de notificaciones para el AppBar global.
 * Muestra un Badge con la cantidad de alertas no leídas y abre el
 * panel lateral derecho (AlertsDrawer) al hacer clic.
 *
 * No renderiza nada si no hay AlertsProvider montado (degradación segura) ni
 * en producción, donde el kit está deshabilitado por usar datos mock.
 */
const AlertsBell = () => {
  const alertsCtx = useAlerts();
  if (!ALERTS_ENABLED || !alertsCtx) return null;

  const { unreadCount, openDrawer } = alertsCtx;

  return (
    <Tooltip title="Notifications">
      <IconButton
        color="inherit"
        aria-label={`open notifications (${unreadCount} unread)`}
        onClick={openDrawer}
      >
        <Badge badgeContent={unreadCount} color="error" max={99}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default AlertsBell;
